<template><div><h1 id="partien" tabindex="-1"><a class="header-anchor" href="#partien"><span>Partien</span></a></h1>
<p>Partien — Bezeichnung von Artikelbeständen im funtrade</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Partien bezeichnen Artikelbestände in funtrade. Eine Partie umfasst die Bestände eines Artikels in einem Lager. Pro Lager kann es aber auch mehrere Partien (mit unterschiedlichen Eigenschaften) geben. Veränderungen in den Partien werden in den sogenannten <RouteLink to="/referenz/refs/ft.refdata.artbeweg.html" title="Artikelbewegungen">Artikelbewegungen</RouteLink> festgehalten.</p>
<p>Ist von einem Artikel eine Partie gleich welchen Typs vorhanden, erscheint der Artikel automatisch im sogenannten Lagersortiment. Lagersortimente können pro Lager verschieden sein. In der <RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink> und in der <RouteLink to="/manual/trade/inventur.html" title="6. Inventur">Inventur</RouteLink> werden diese Lagersortimente berücksichtigt.</p>
<p>Manuelle Eingriffe an T-Partien sind nicht möglich. T-Partien werden ausschliesslich über die Umlagerungsaufträge bewirtschaftet und im Partienfenster lediglich angezeigt.</p>
<h2 id="partientypen" tabindex="-1"><a class="header-anchor" href="#partientypen"><span>Partientypen</span></a></h2>
<p>V: Verkaufbare Partie</p>
<p>D: Defektpartie</p>
<p>R: Retourpartie</p>
<p>T: Transitpartie (bei <RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html#lag-umlagerungen" title="3.4.1. Umlagerungen">Umlagerungen</RouteLink> )</p>
<p>N: Nicht verkaufbare Partie</p>
<p>M: Musterpartie</p>
<h2 id="fenster-partien" tabindex="-1"><a class="header-anchor" href="#fenster-partien"><span>Fenster Partien</span></a></h2>
<p>Das Fenster zeigt sämtliche, für den gewählten Artikel verfügbaren Partien, d.h. alle Bestände, die von diesem Artikel existieren.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Artikel (Kurzform):</dt>
<dd>
<p>Standard</p>
</dd>
<dt>PNr:</dt>
<dd>
<p>Partientyp, Laufnummer zur eindeutigen Kennzeichnung einer Partie (wenn mehrere Partien gleichen Typs erfasst wurden, sonst Laufnummer immer 1). Die einzelnen Partien werden im Fenster absteigend nach Partientyp; aufsteigend nach Laufnummer sortiert. Damit erscheinen pro Lager die V-Partien zuerst. Primäre Sortierung nach Personen-ID des Lagers</p>
</dd>
<dt>Lager:</dt>
<dd>
<p>Personen-ID des Lagers</p>
</dd>
<dt>LBez.:</dt>
<dd>
<p>Anzeige der Lagerbezeichnung aus der Tabelle &quot;Lagerorte&quot;</p>
</dd>
<dt>Bemerkung:</dt>
<dd>
<p>Freies Textfeld zur näheren Bezeichnung einer Partie, 18 Zeichen, alphanumerisch</p>
</dd>
<dt>Lplatz:</dt>
<dd>
<p>Lagerplatz, kennzeichnet den physischen &quot;Aufenthaltsort&quot; eines Artikels innerhalb eines Lagers, freies Textfeld, 6 Zeichen, alphanumerisch</p>
</dd>
<dt>Menge:</dt>
<dd>
<p>Artikelbestand, 6-stellig</p>
</dd>
<dt>VerfallD:</dt>
<dd>
<p>Verfalldatum der Partie</p>
</dd>
<dt>Eig:</dt>
<dd>
<p>Eigentumsstatus,</p>
</dd>
<dd>
<p>1 = intern</p>
</dd>
<dd>
<p>2 = extern (Lieferant)</p>
</dd>
<dt>ErfDat:</dt>
<dd>
<p>Erfassungsdatum der Partie, bzw. Mutationsdatum</p>
</dd>
<dt>Erf:</dt>
<dd>
<p>Kürzel des Erfassers bzw. desjenigen, der die letzte Mutation ausführte</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>gehezu:</dt>
<dd>Standardsuche wie im Artikel</dd>
<dt>Filter:</dt>
<dd>Einschränkung nach Artikelfilter</dd>
<dt>erfP:</dt>
<dd>Erfassen einer neuen Partie</dd>
<dt>ändP:</dt>
<dd>Ändern einer bestehenden Partie. Es können die Felder [Bemerkung], [LPlatz] und [VerfallD] geändert werden</dd>
<dt>löschP:</dt>
<dd>Löschen einer Partie. Nur möglich, wenn der Bestand 0 beträgt. Wenn in einem bestimmten Lager keine Partie mehr besteht, fällt der Artikel aus dem Lagersortiment</dd>
<dt>Umbuch.:</dt>
<dd>Umbuchen von Artikeln, Details siehe Fenster Umbuchung</dd>
<dt>Idx:</dt>
<dd>Index wie im Artikel</dd>
<dt>Zoom:</dt>
<dd>Übersichtsfenster zur manuellen Suche von Artikeln</dd>
<dt>drucken:</dt>
<dd>Drucken des Fensters. Es können gleichzeitig mehrere Artikel gedruckt werden</dd>
<dt>vArt:</dt>
<dd>Vorheriger Artikel: behält Fenster Partien bei, wechselt zum vorherigen Artikel, abhängig vom Index</dd>
<dt>nArt:</dt>
<dd>Nächster Artikel: behält Fenster Partien bei, wechselt zum nächsten Artikel, abhängig vom Index</dd>
<dt>./.</dt>
<dd>Umfeldmenü</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.partienbereinigen.html" title="Partien bereinigen">Partien bereinigen</RouteLink></p>
</div></template>


